import { BlockType, blockTypeSchema } from 'blocks/BlockType';
import { z } from 'zod';

export interface IBaseBlockData {
    id: number;
    type: BlockType;
    highlight: boolean;
    enabled?: boolean;
}

export const baseBlockSchema = z.object({
    id: z.number(),
    type: blockTypeSchema,
    highlight: z.boolean().optional().default(false),
    enabled: z.boolean().optional().default(true),
});
